// Работа с капчей.

// Инициализирует капчу в указанном контейнере.
// https://cloud.yandex.ru/docs/smartcaptcha/operations/advanced-method
const init = (selector, invisible = false) => {
    if (!window.smartCaptcha) {
        return undefined;
    }
    const container = document.querySelector(selector);
    if (!container) {
        return undefined;
    }
    return window.smartCaptcha.render(container, {
        sitekey: container.dataset.sitekey,
        hl: "ru",
        hideShield: true,
        invisible,
    });
};

// Проверяет человечность пользователя по капче.
// Если не прошла проверка при невидимой капче, показывает ее.
const execute = id => {
    if (!window.smartCaptcha) {
        return;
    }
    window.smartCaptcha.execute(id);
};

// Удаляет и создает заново капчу в видимом режиме
const reinit = (id, selector) => {
    if (!window.smartCaptcha) {
        return null;
    }
    window.smartCaptcha.destroy(id);
    return init(selector, false);
};

export default {
    init,
    execute,
    reinit,
};
